import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { GameSettingsProvider } from './contexts/GameSettingsContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <GameSettingsProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </GameSettingsProvider>
  </React.StrictMode>
);
